import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';
import GeneralDialog from '../GeneralDialog';
import ChangePassword from '../../containers/sideDrawer/ChangePassword';
import PropTypes from 'prop-types';
import ChangeLangaugeMenu from '../../components/ChangeLanguageMenu';

const styles =  (theme) => ({
    list: {
      width: 250,
      height:'100vh',
      background:'#99192D',
      color:'white'
    },
    fullList: {
      width: 'auto',
    },
    nested: {
      paddingLeft: theme.spacing.unit * 4,
    },
    link: {
      textDecoration: 'none',
      color:'white'
    },
});

class SideDrawer extends Component{
    
  state = {
    openCaseFileList: false,
    openOnlineArbitrationList: false,
    openSettingList: false,
  };

  handleClick = (openList) => {
    this.setState(state => ({ [openList]: !state[openList] }));
  };
    
  render(){
    const { classes, toggleDrawer, openDrawer} = this.props;
    const { openCaseFileList, openOnlineArbitrationList, openSettingList } = this.state;
    let sideList;
    if (localStorage.getItem('typeOfAccount') == 'admin'){
      sideList = (props) => (
    <div className={classes.list}>
      <List component="nav">
        <ChangeLangaugeMenu menuStyle={{marginLeft:'33px'}} />
        <Link to={'/cases'} className={classes.link}>
          <ListItem button className={classes.nested}>
            <ListItemText disableTypography primary={this.context.t('All Cases')} />
          </ListItem>
        </Link>
        <Link to={'/arbitrationAgreements'} className={classes.link}>
          <ListItem button className={classes.nested}>
            <ListItemText disableTypography  primary={this.context.t('Arbitration Agreement')} />
          </ListItem>
        </Link>
        {/* <GeneralDialog key={5} title={this.context.t('Change Password')} component={<ChangePassword />} location='sideDrawer'/> */}
        <Divider />
        <Link to='/logout' className={classes.link}>
          <ListItem button className={classes.nested} onClick={toggleDrawer('right', false)}>
              <ListItemText disableTypography  primary={this.context.t('Logout')} />
          </ListItem>
        </Link>
      </List>
    </div>
  );
    }else{
      sideList = (props) => (
        <div className={classes.list}>
          <List  component="nav">
            <ChangeLangaugeMenu menuStyle={{marginLeft:'33px'}} />
            <Link to={'/cases'} className={classes.link}>
              <ListItem button className={classes.nested}>
                <ListItemText disableTypography  primary={this.context.t('All Cases')} />
              </ListItem>
            </Link>
            {/* <GeneralDialog key={4} title={this.context.t('Change Password')} component={<ChangePassword />} location='sideDrawer'/> */}
            <Divider />
            <Link to='/logout' className={classes.link}>
              <ListItem button className={classes.nested} onClick={toggleDrawer('right', false)}>
                  <ListItemText disableTypography primary={this.context.t('Logout')} />
              </ListItem>
            </Link>
          </List>
        </div>
      );
    }
    

    return(
      <div>
          <Drawer anchor="right" open={openDrawer} onClose={toggleDrawer('right', false)}>
          <div
              tabIndex={0}
              role="button"
              //onClick={toggleDrawer('right', false)}
              //onKeyDown={toggleDrawer('right', false)}
          >
              {sideList(toggleDrawer)}
          </div>
      </Drawer>
      </div>
  );
  }
    
}

SideDrawer.contextTypes = {
  t: PropTypes.func
}

export default withStyles(styles)(SideDrawer);